import pressFontSizes from './font-sizes-press';
import { headingAliases, Heading, headings } from './components/headings';
// const fontSizes = [8, 10.2, 12.8, 16, 20, 25, 31.3, 39.1, 48.8, 61, 76.3, 95.4, 119.2];
// const indicies = [0,     1,    2,  3,  4,  5,    6,    7,    8,  9,   10,   11,    12];

type BaseFontSize =
  | 'fs8'
  | 'fs10'
  | 'fs12'
  | 'fs16'
  | 'fs20'
  | 'fs25'
  | 'fs31'
  | 'fs39'
  | 'fs49'
  | 'fs61'
  | 'fs76'
  | 'fs95'
  | 'fs119';

type BaseFontSizeAliases = Record<BaseFontSize, number>;

export type BaseFontSizes = number[] & Partial<BaseFontSizeAliases>;

const baseFontSizes: BaseFontSizes = [
  8,
  10.2,
  12.8,
  16,
  20,
  25,
  31.3,
  39.1,
  48.8,
  61,
  76.3,
  95.4,
  119.2
];

export const baseFontSizeAliases: BaseFontSizeAliases = {
  fs8: baseFontSizes[0],
  fs10: baseFontSizes[1],
  fs12: baseFontSizes[2],
  fs16: baseFontSizes[3],
  fs20: baseFontSizes[4],
  fs25: baseFontSizes[5],
  fs31: baseFontSizes[6],
  fs39: baseFontSizes[7],
  fs49: baseFontSizes[8],
  fs61: baseFontSizes[9],
  fs76: baseFontSizes[10],
  fs95: baseFontSizes[11],
  fs119: baseFontSizes[12]
};

Object.keys(baseFontSizeAliases).forEach(fontSize => {
  const baseFontSizeKey = fontSize as BaseFontSize;
  baseFontSizes[baseFontSizeKey] = baseFontSizeAliases[baseFontSizeKey];
});

Object.entries(headingAliases).forEach(heading => {
  const header = heading[0] as Heading;
  const fontSize = heading[1];
  headings[header] = fontSize;
});

const allFontSizes = {
  ...baseFontSizes,
  ...headings
};

const fontSizes = {
  ...allFontSizes,
  products: {
    chart: allFontSizes,
    co: allFontSizes,
    edu: allFontSizes,
    press: pressFontSizes,
    spark: allFontSizes
  }
};

export default fontSizes;
